module.exports = __webpack_public_path__ + "static/bg-with-vectors-95b0b48b392c8fe2f6f26b50445912b6.svg";